// Embrace (Venus): the stars on a loop around a planet score +200% instead
// of the usual +100% (scoring/score.ts reads loopPercent).
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { LOOP_PERCENT } from '../../scoring/score';
import type { AlignmentDef } from '../types';

export const embrace: AlignmentDef = {
  id: 'embrace',
  planet: 'venus',
  name: 'Embrace',
  text: () => `Stars on a loop around a planet score +${N.embraceLoopPercent}% instead of +${LOOP_PERCENT}%.`,
  loopPercent: N.embraceLoopPercent,
};
